import React from 'react';
import { OrderHistoryStatus } from "../modules/user/stock-order-history";

export const getStatusText = (status: OrderHistoryStatus) => {
    let color = '';
    let text = '';

    switch (status) {
        case 'pending':
            color = '#1890ff';
            text = 'Pending';
            break;
        case 'partially_filled':
            color = '#1890ff';
            text = 'Partially Filled';
            break;
        case 'completed':
            color = '#52c41a';
            text = 'Completed';
            break;
        case 'cancelled':
            color = '#ff4d4f';
            text = 'Cancelled';
            break;
        default:
            break;
    }

    return <span style={{ color }}>{text}</span>;
};